import { useEffect } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

const tetapkanMeta = (pemilih, atribut, nilai, kandungan) => {
  let el = document.head.querySelector(pemilih);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(atribut, nilai);
    document.head.appendChild(el);
  }
  el.setAttribute("content", kandungan);
};

/* Kemas kini tajuk dan meta perkongsian bagi setiap halaman.
   Nota: WhatsApp dan Facebook membaca meta dalam public/index.html.
   Fungsi ini memastikan tajuk pelayar dan perkongsian dalam aplikasi kekal tepat. */
export const useSeo = ({ tajuk, keterangan, imej, laluan }) => {
  useEffect(() => {
    const tajukPenuh = tajuk
      ? `${tajuk} | Kamil Munim, P.061 Padang Rengas`
      : "Dashboard Kempen Kamil Munim | P.061 Padang Rengas";
    document.title = tajukPenuh;

    if (keterangan) {
      tetapkanMeta('meta[name="description"]', "name", "description", keterangan);
      tetapkanMeta('meta[property="og:description"]', "property", "og:description", keterangan);
      tetapkanMeta('meta[name="twitter:description"]', "name", "twitter:description", keterangan);
    }

    tetapkanMeta('meta[property="og:title"]', "property", "og:title", tajukPenuh);
    tetapkanMeta('meta[name="twitter:title"]', "name", "twitter:title", tajukPenuh);

    const urlImej = `${BACKEND}${imej || "/og-image.jpg"}`;
    tetapkanMeta('meta[property="og:image"]', "property", "og:image", urlImej);
    tetapkanMeta('meta[name="twitter:image"]', "name", "twitter:image", urlImej);

    if (laluan) {
      tetapkanMeta('meta[property="og:url"]', "property", "og:url", `${BACKEND}${laluan}`);
      let kanonikal = document.head.querySelector('link[rel="canonical"]');
      if (!kanonikal) {
        kanonikal = document.createElement("link");
        kanonikal.setAttribute("rel", "canonical");
        document.head.appendChild(kanonikal);
      }
      kanonikal.setAttribute("href", `${BACKEND}${laluan}`);
    }
  }, [tajuk, keterangan, imej, laluan]);
};
